/** Legacy deals without an assigned agreement retain their stored-signature behavior. */
export function hasSignedDealAgreement(
  deal:
    | {
        agreementId?: number | null;
        agreementSignatures?: { agreementId?: number | null }[];
      }
    | null
    | undefined,
): boolean {
  return !!deal?.agreementSignatures?.some(
    (signature) =>
      deal.agreementId == null ||
      (signature.agreementId != null &&
        Number(signature.agreementId) === Number(deal.agreementId)),
  );
}
